import { getComprasIndividual, getItemsUtilidad, getComprasHistorico, putPagarCompraIndividual, getPagosAutorizadosGrupal, putPagarCompraGrupal, getComprasGrupalHistorico, deleteCancelarCompra, deleteCancelarCompraGrupal, getDetallePagoGrupal } from "../services/comprasService"
import { postComprobantePagoIndividual, postComprobantePagoGrupal } from "../services/documentosService";
import { getMovimeintosDolares, getCorteBusqueda, postNewCorte } from "../services/cashRegisterServices"
import { getDetalleGrupo, getGrupoViajeUtilidadFecha } from "../services/serviceViaje";

const dataInicial = {
  ItemsIndiviudal: [],
  ItemsGrupal: [],
  ItemsUtilidad: [],
  ComprasHistorico: {},
  ComprasHistoricoGrupal: {},
  exito: 0,
  fechaIndividual: "",
  movimientosCuenta: {},
  cortesMovimeinto: [],
  movimientoFechaIni: "",
  movimeintoFechaFin: "",
  utilidadGrupo: {},
  detalleGrupo: [],
};
const GET_FINANZAS_DETALLE_GRUPO = "GET_FINANZAS_DETALLE_GRUPO"
const GET_FINANZAS_UTILIDAD_GRUPAL = "GET_FINANZAS_UTILIDAD_GRUPAL"
const GET_FINNAZAS_ITEMS_UTILIDAD = "GET_FINNAZAS_ITEMS_UTILIDAD"
const GET_FINANZAS_PAGAR_GRUPAL = "GET_FINANZAS_PAGAR_GRUPAL"
const GET_FINANZAS_PAGAR_INDIVIDUAL = "GET_FINANZAS_PAGAR_INDIVIDUAL"
const GET_FINANZAS_PAGADO_INDIVIDUAL = "GET_FINANZAS_PAGADO_INDIVIDUAL"
const GET_FINANZAS_PAGADO_GRUPAL = "GET_FINANZAS_PAGADO_GRUPAL"
const PUT_FINANZAS_PAGAR_INDIVIDUAL = "PUT_FINANZAS_PAGAR_INDIVIDUAL"
const PUT_FINANZAS_COMPROBANTE_INDIVIDUAL = "PUT_FINANZAS_COMPROBANTE_INDIVIDUAL"
const PUT_FINANZAS_COMPROBANTE_GRUPAL = "PUT_FINANZAS_COMPROBANTE_GRUPAL"
const PUT_FINANZAS_PAGAR_GRUPAL = "PUT_FINANZAS_PAGAR_GRUPAL"
const DELETE_FINANZAS_PAGAR_INDIVIDUAL = "DELETE_FINANZAS_PAGAR_INDIVIDUAL"
const DELETE_FINANZAS_PAGAR_GRUPAL = "DELETE_FINANZAS_PAGAR_GRUPAL"
const GET_FINANZAS_MOVIMIENTOS_CUENTA = "GET_FINANZAS_MOVIMIENTOS_CUENTA"
const GET_FINANZAS_CORTES_MOVIMIENTOS = "GET_FINANZAS_CORTES_MOVIMIENTOS"
const POST_FINANZAS_NEW_CORTE = "POST_FINANZAS_NEW_CORTE"
const CLEAR_STATE = "CLEAR_STATE"

export default function finanzasReducer(state = dataInicial, action) {
  switch (action.type) {
    case GET_FINANZAS_DETALLE_GRUPO:
      return { ...state, detalleGrupo: action.payload.detalleGrupo }
    case GET_FINANZAS_UTILIDAD_GRUPAL:
      return { ...state, utilidadGrupo: action.payload.utilidadGrupo }
    case DELETE_FINANZAS_PAGAR_GRUPAL:
      return { ...state, exito: action.payload.exito }
    case DELETE_FINANZAS_PAGAR_INDIVIDUAL:
      return { ...state, exito: action.payload.exito }
    case GET_FINNAZAS_ITEMS_UTILIDAD:
      return { ...state, ItemsUtilidad: action.payload.ItemsUtilidad }
    case POST_FINANZAS_NEW_CORTE:
      return { ...state, exito: action.payload.exito }
    case GET_FINANZAS_CORTES_MOVIMIENTOS:
      return { ...state, cortesMovimeinto: action.payload.cortesMovimeinto }
    case GET_FINANZAS_MOVIMIENTOS_CUENTA:
      return { ...state, movimientosCuenta: action.payload.movimientosCuenta, movimientoFechaIni: action.payload.movimientoFechaIni, movimeintoFechaFin: action.payload.movimeintoFechaFin }
    case PUT_FINANZAS_COMPROBANTE_GRUPAL:
      return { ...state, exito: action.payload.exito }
    case PUT_FINANZAS_PAGAR_GRUPAL:
      return { ...state, exito: action.payload.exito }
    case GET_FINANZAS_PAGAR_GRUPAL:
      return { ...state, ItemsGrupal: action.payload.ItemsGrupal }
    case PUT_FINANZAS_COMPROBANTE_INDIVIDUAL:
      return { ...state, exito: action.payload.exito }
    case GET_FINANZAS_PAGADO_INDIVIDUAL:
      return { ...state, ComprasHistorico: action.payload.ComprasHistorico, fechaIndividual: action.payload.fechaIndividual }
    case GET_FINANZAS_PAGADO_GRUPAL:
      return { ...state, ComprasHistoricoGrupal: action.payload.ComprasHistoricoGrupal }
    case PUT_FINANZAS_PAGAR_INDIVIDUAL:
      return { ...state, exito: action.payload.exito }
    case GET_FINANZAS_PAGAR_INDIVIDUAL:
      return { ...state, ItemsIndiviudal: action.payload.ItemsIndiviudal }
    case CLEAR_STATE:
      return {
        ...state,
        ItemsIndiviudal: action.payload.ItemsIndiviudal,
      };
    default:
      return state;
  }
}
export const obtenerDetalledGrupalAction = ({ idPagoGrupal }) => async (dispatch) => {
  return await getDetallePagoGrupal({ IdPagoGrupal: idPagoGrupal }).then(Resposne => {
    dispatch({
      type: GET_FINANZAS_DETALLE_GRUPO,
      payload: {
        detalleGrupo: Resposne
      }
    })
  })
}
export const obtenerUtilidadGrupalAction = ({ FechaIni, FechaFin }) => async (dispatch) => {
  return await getGrupoViajeUtilidadFecha({ FechaFin, FechaIni }).then(Resposne => {
    dispatch({
      type: GET_FINANZAS_UTILIDAD_GRUPAL,
      payload: {
        utilidadGrupo: Resposne
      }
    })
  })
}
export const nuevoCorteCaja = ({ TipoCambio }) => async (dispatch) => {
  return await postNewCorte({ TipoCambio }).then(Resposne => {
    dispatch({
      type: POST_FINANZAS_NEW_CORTE,
      payload: {
        exito: 1
      }
    })
    return Resposne
  }).catch(Error => {
    return Error
  })
}
export const obtenerCortesCajaAction = ({ FechaBusqueda }) => async (dispatch) => {
  return await getCorteBusqueda({ FechaBusqueda }).then(Resposne => {
    dispatch({
      type: GET_FINANZAS_CORTES_MOVIMIENTOS,
      payload: {
        cortesMovimeinto: Resposne
      }
    })
  })
}
export const obtenerMovientosUSDAction = ({ FechaInicio, FechaFinal }) => async (dispatch) => {
  return await getMovimeintosDolares({ FechaInicio, FechaFinal }).then(Resposne => {
    dispatch({
      type: GET_FINANZAS_MOVIMIENTOS_CUENTA,
      payload: {
        movimientosCuenta: Resposne,
        movimientoFechaIni: FechaInicio,
        movimeintoFechaFin: FechaFinal
      }
    })
  })
}
export const pagarCompraGrupal = ({ idPagoGrupal, TipoCambio }) => async (dispatch) => {
  return await putPagarCompraGrupal({ idPagoGrupal, TipoCambio }).then(Resposne => {
    dispatch({
      type: PUT_FINANZAS_PAGAR_GRUPAL,
      payload: {
        exito: 1
      }
    })
    return Resposne
  }).catch(Error => {
    return Error
  })
}
export const obtenerItemsGrupal = () => async (dispatch) => {
  return await getPagosAutorizadosGrupal().then(Resposne => {
    dispatch({
      type: GET_FINANZAS_PAGAR_GRUPAL,
      payload: {
        ItemsGrupal: Resposne
      }
    })
  })
}
export const cargarComprobanteIndividual = ({ idCompra, Imagen, ExtensionImagen, Nombre }) => async (dispatch) => {
  return await postComprobantePagoIndividual({ idCompra, Imagen, Extension: ExtensionImagen, Nombre }).then(Resposne => {
    dispatch({
      type: PUT_FINANZAS_COMPROBANTE_INDIVIDUAL,
      payload: {
        exito: 1
      }
    })
    return Resposne
  }).catch(Error => {
    return Error
  })
}
export const cargarComprobanteGrupal = ({ idPagoGrupal, Imagen, ExtensionImagen, Nombre }) => async (dispatch) => {
  return await postComprobantePagoGrupal({ idPagoGrupal, Imagen, Extension: ExtensionImagen, Nombre }).then(Resposne => {
    dispatch({
      type: PUT_FINANZAS_COMPROBANTE_GRUPAL,
      payload: {
        exito: 1
      }
    })
    return Resposne
  }).catch(Error => {
    return Error
  })
}
export const cancelarCompraIndividual = ({ idCompra }) => async (dispatch) => {
  return await deleteCancelarCompra({ idCompra }).then(Resposne => {
    dispatch({
      type: DELETE_FINANZAS_PAGAR_INDIVIDUAL,
      payload: {
        exito: 1
      }
    })
    return Resposne
  }).catch(Error => {
    return Error
  })
}
export const cancelarCompraGrupal = ({ idPagoGrupal }) => async (dispatch) => {
  return await deleteCancelarCompraGrupal({ idPagoGrupal }).then(Resposne => {
    dispatch({
      type: DELETE_FINANZAS_PAGAR_INDIVIDUAL,
      payload: {
        exito: 1
      }
    })
    return Resposne
  }).catch(Error => {
    return Error
  })
}

export const pagarCompraIndividual = ({ idCompra, TipoCambio, fechaPago }) => async (dispatch) => {
  return await putPagarCompraIndividual({ idCompra, TipoCambio, fechaPago }).then(Resposne => {
    dispatch({
      type: PUT_FINANZAS_PAGAR_INDIVIDUAL,
      payload: {
        exito: 1
      }
    })
    return Resposne
  }).catch(Error => {
    return Error
  })
}
export const obtenerItemsIndividual = () => async (dispatch) => {
  return await getComprasIndividual().then(Resposne => {
    dispatch({
      type: GET_FINANZAS_PAGAR_INDIVIDUAL,
      payload: {
        ItemsIndiviudal: Resposne
      }
    })
  })
}
export const obtenerComprasHistorico = ({ fecha }) => async (dispatch) => {
  return await getComprasHistorico({ fecha }).then(Resposne => {
    dispatch({
      type: GET_FINANZAS_PAGADO_INDIVIDUAL,
      payload: {
        ComprasHistorico: Resposne,
        fechaIndividual: fecha
      }
    })
  })
}
export const obtenerComprasHistoricoGrupal = ({ fecha }) => async (dispatch) => {
  return await getComprasGrupalHistorico({ fecha }).then(Resposne => {
    dispatch({
      type: GET_FINANZAS_PAGADO_GRUPAL,
      payload: {
        ComprasHistoricoGrupal: Resposne,
        fechaIndividual: fecha
      }
    })
  })
}
export const obtenerItemsUtiliad = ({ fecha }) => async (dispatch) => {
  return await getItemsUtilidad({ fecha }).then(Resposne => {
    dispatch({
      type: GET_FINNAZAS_ITEMS_UTILIDAD,
      payload: {
        ItemsUtilidad: Resposne
      }
    })
  })
}
export const clearState = () => async (dispatch) => {
  dispatch({
    type: CLEAR_STATE,
    payload: dataInicial
  })
}
